var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfographicPublication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.79,118.17H144.3m-30.51-11.94H144.3m-42.62,54.52H144.3m-42.62-12.17H144.3m-42.62-73H144.3M101.68,63.42H144.3M95.85,123.8H72.07V99.7H95.85ZM84,166.16H72.06V142.05H84Zm0-84H72.06V58H84Zm78.3,102.29H53.9V39.08H162.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfographicPublication);
export default __webpack_public_path__ + "static/media/INFOGRAPHIC_PUBLICATION.8428cf3449718a51c83c548ee1324fed.svg";
export { ForwardRef as ReactComponent };